export default __webpack_public_path__ + "static/media/sticker-n.24edb6d3.png";